import { useAuth } from '../contexts/AuthContext';

// useFeature("agents.agent_crud") -> boolean
// Internal admins always get true.
export const useFeature = (dottedCode) => {
  const { access } = useAuth();
  if (access?.internal_admin) return true;
  return Array.isArray(access?.features) && access.features.includes(dottedCode);
};

export default useFeature;
